module.exports = __webpack_public_path__ + "b1e2e1f3ec462f6384273e920fd1a45f.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/photo-backgrounds/animals/Elebhant1.jpg
// module id = 3464
// module chunks = 0